/**
 * The cases constants module houses cases-specific configurations.
 *
 * @module routes.simulation.widgets.constants
 */

angular.module('routes.simulation.widgets.constants', [])
  .config([
    '$provide',
    function ($provide) {
      'use strict';

      // Define.
      var widgets;

      // Set defaults.
      widgets = {
        templates: [],
        models: []
      };

      // TODO: This should be done in a more efficient manner
      // configs should be imported or loaded, not hardcoded
      widgets.templates['state.learningOutcomes'] = {
        rule: {
          stop: true,
          scored: false,
          active: true,
          totalPoints: 0,
          decision: {
            multiple: false,
            scored: false,
            model: 'none',
            choices: [
              {
                correct: true,
                target: '_self',
                id: 'string',
                feedback: 'string',
                points: 0
              }
            ]
          }
        },
        decision: {
          stem: '',
          choices: [
            {
              id: '',
              label: ''
            }
          ]
        }
      };

      widgets.models['state.learningOutcomes'] = {
        title: '',
        list: [
          {
            value: ''
          }
        ],
        choices: [
          {
            value: '',
            target: '',
            points: 0
          }
        ]
      };

      /**
       * Defines widgets constants.
       *
       * @attribute WIDGETS
       * @type String
       * @readOnly
       */
      $provide.constant('WIDGETS', widgets);
    }
  ]);
